<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-2 p-pb-6">
      <div class="p-grid p-ai-center vertical-container">
          <!-- <div class="p-col-fixed" style="width:55px;">
              <a @click="$functions.historyBack()" style="cursor: pointer">
                <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
              </a>
          </div> -->
          <div class="p-col">
              <h3 v-if="reportId!=null && serialNumber!=null">{{ serialNumber }} - (Report id: {{ reportId }})</h3>
              <h3 v-else>{{ $t('report.edit.title') }}</h3>
          </div>
          <div v-if="gamma!=null && $config.currentEnv=='dev'" class="p-col-fixed p-text-right " style="width: 200px">
              <span style="font-size: .8rem; color: #A70008;">{{ extras.imperial ? $t('preferences.ms.imperial') : $t('preferences.ms.metric') }}</span>
          </div>
      </div>

      <div class="irinox-form report-installazione">


        <div v-show="step===0" class="p-formgroup-inline p-ai-center">
          <div class="p-field">
            <Dropdown id="gamme" v-model="gamma" :options="gamme" optionLabel="name" optionValue="code"
              :placeholder="$t('report.edit.filter_gamma_ph')" style="width: 200px" :disabled="reportId!=null/* || gamma!=null*/"/>
          </div>
        </div>

        <div v-if="report && gamma && (role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')">
          <div v-for="(value, key, index) in structures[gamma]" :key="'section_'+key">
            <Section v-if="step===index" :name="key" :structure="value" :data="report[key]" :reportId="reportId" :domains="domains" :extras="extras" @update:data="dataChanged"/> 
          </div>
          
          <Overview v-if="step>Object.keys(structures[gamma]).length-1" :reportId="reportId" :report="report" :extras="extras"
            :structure="structures[gamma]" :domains="domains"
            @update:data="dataChanged" 
            @update:images="imagesChanged" 
            @update:signature="signatureChanged" 
          />
        </div>
        <div v-if="report && gamma && role.includes('INTERNAL')">
          <Overview v-if="step>Object.keys(structures[gamma]).length-1" :reportId="reportId" :report="report" :extras="extras"
            :structure="structures[gamma]" :domains="domains"
            @update:data="dataChanged" 
            @update:images="imagesChanged" 
            @update:signature="signatureChanged" 
          />
        </div>

        <div v-if="structures[gamma] && step>=0 && (role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')" class="footer">

          <Button :label="$t('report.edit.button_exit')" @click="exit" class="p-button-outlined p-button-danger on-the-left p-ml-3" />

          <Button v-if="step>0" :label="$t('report.edit.button_back')" @click="back" class="p-button-secondary" />

          <div style="display: inline-block;" v-tooltip.top="{ value: $t('report.edit.button_save_tooltip'), disabled: !buttons.saveDisabled }">
            <Button :label="$t('report.edit.button_save')" @click="save" class="p-button-secondary" :disabled="buttons.saveDisabled"/>
          </div>

          <Button v-if="step<=Object.keys(structures[gamma]).length-1" :label="$t('report.edit.button_next')" @click="next"/>

          <div style="display: inline-block;" v-tooltip.top="{ value: $t('report.edit.button_send_tooltip'), disabled: !buttons.sendDisabled }">
            <Button v-if="step>Object.keys(structures[gamma]).length-1" :label="$t('report.edit.button_send')" @click="send" :disabled="buttons.sendDisabled" />
          </div>

        </div>
        <div v-if="structures[gamma] && step>=0 && role.includes('INTERNAL')" class="footer">

          <Button :label="$t('report.edit.button_exit')" @click="exit" class="p-button-outlined p-button-danger on-the-left p-ml-3" />

        </div>

      </div>

    </div>
  </div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />

  <IrinoxDialogDark :visible="dialog.saveSuccess" 
    mode="success" 
    :message="$t('report.edit.save_report_success')"
    :life="3000" 
    @update:visible="dialog.saveSuccess = $event" />

  <IrinoxDialogDark :visible="dialog.sendSuccess" 
    mode="success" 
    :message="$t('report.edit.send_report_success')"
    :life="3000" 
    @update:visible="dialog.sendSuccess = $event" />

</template>

<script>
import ReportService from '../../service/ReportService';
import ApplianceService from '../../service/ApplianceService';
import Section from './Section';
import Overview from './Overview';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
import structure_cp from '../../../public/json/reports/structures/cp.json';
import structure_mya from '../../../public/json/reports/structures/mya.json';
import structure_mfnext from '../../../public/json/reports/structures/mfnext.json';
import structure_mpnext from '../../../public/json/reports/structures/mpnext.json';
import structure_efnext from '../../../public/json/reports/structures/efnext.json';
import structure_sf from '../../../public/json/reports/structures/sf.json';
import structure_prime from '../../../public/json/reports/structures/prime.json';
import rawDomains from '../../../public/json/reports/domains.json';
import countries from '../../../public/assets/demo/data/countries.json';

export default {
  components: {
    IrinoxDialogDark,
    // IrinoxDialogLight,
    Section,
    Overview,
  },
  data() {
    return {
      domains: {},
      countries: countries,
      structures: {},
      serialNumber: this.$route.params.serialNumber,
      reportId: this.$route.params.reportId,
      report: null,
      signatureData: null,
      gamme: [],
      gamma: null,
      models: [],
      modelId: null,
      serials: [],
      extras: {},
      dialog: {
        error: false,
        blockingError: false,
        saveSuccess: false,
        sendSuccess: false,
      },
      step: -1,
      buttons: {
        saveDisabled: true,
        sendDisabled: true,
      }
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      unit: 'userdata/unit',
      isCelsius: 'userdata/isCelsius',
      role: 'userdata/role',
      appliances: 'appliances/appliances',
    }),
  },
  created() {
    this.reportService = new ReportService();
    this.applianceService = new ApplianceService();
    this.fillDomains();
    this.fillDomainCountries();
  },
  mounted() {
    // !!! TUTTO QUESTO SERVIVA PER MOSTRARE ELENCO MACCHINE IN TENDINA (ORA E' SOLO TESTO CON CONTROLLI SULLA SINTASSI)
    // if(this.role.includes('FACTORY') || this.role==="SUBSIDIARY" || this.role.includes("INTERNAL")) {
    //   this.reloadFactoryAppliances();
    // } else {
    //   this.reloadServiceAppliances();
    // }
    this.loadModels();
  },
  watch: {
    // storedRecipe: 'updateTemporaryRecipe',
    gamma: 'gammaChanged',
    'report.REPORT.model': 'modelChanged'
  },
  methods: {
    updateButtonsStatus() {
      this.buttons.saveDisabled = !(this.report["REPORT"] && this.report["REPORT"]["serial_number"] && this.report["REPORT"]["model"]);
      if(this.step>Object.keys(this.structures[this.gamma]).length-1) {
        this.buttons.sendDisabled = !(this.report["REPORT"] && this.isFormValid() && this.reportId && this.signatureData);
      } else {
        this.buttons.sendDisabled = true;
      }
    },
    loadReport() {
      this.reportService.get(this.personaltoken, this.reportId)
        .then((data) => {
          if(data.code=='200') {
            this.report = data.body;
            this.extras.imperial = this.report["imperial"] ?? false;
            this.gamma = this.report && this.report["REPORT"] ? this.report["REPORT"].gamma : null;
            this.fillDomainModels();
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.report = null;
            this.dialog.error = true;
            setTimeout(function () {
              this.$functions.historyBack();
            }.bind(this), 3000);
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.report = null;
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    loadModels() {
      this.reportService.models(this.personaltoken)
        .then((data) => {
          this.models = data;
          // this.models.push({"modelId":"EF Next S","gamma":"EF Next","accessory":"","name":"S"});
          // this.models.push({"modelId":"EF Next M","gamma":"EF Next","accessory":"","name":"M"});
          // this.models.push({"modelId":"EF Next L","gamma":"EF Next","accessory":"","name":"L"});
          // this.models.push({"modelId":"EF Next SL","gamma":"EF Next","accessory":"","name":"SL"});
          // this.models.push({"modelId":"EF Next ML","gamma":"EF Next","accessory":"","name":"ML"});
          // this.models.push({"modelId":"EF Next LL","gamma":"EF Next","accessory":"","name":"LL"});
          this.models.push({"modelId":"PRIME","gamma":"PRIME","accessory":"","name":""});
          let gs = [];
          for(let i=0; i<this.models.length; i++) {
            // if(this.models[i].gamma!="MP Next") {
              gs.push({ code: this.models[i].gamma, name: this.$functions.fixGamma(this.models[i].gamma) });
            // }
          }
          this.gamme = this.$functions.uniqByKeepFirst(gs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));

          if(this.reportId!=null) {
            this.loadReport();
          } else {
            this.report = {}
            this.step = 0;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.models = [];
          this.gamme = [];
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    reloadServiceAppliances() {
      this.applianceService.getAppliances(this.personaltoken)
        .then((appliances) => {
          this.$store.commit('appliances/appliances', appliances);
          this.loadModels();
        })
        .catch(error => {
          console.error("EXCEPTION " + error);
          this.$store.commit('appliances/appliances', []);
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    reloadFactoryAppliances() {
      this.applianceService.getFactoryAppliances(this.personaltoken)
        .then((appliances) => {
          this.$store.commit('appliances/appliances', appliances);
          this.loadModels();
        })
        .catch(error => {
          console.error("EXCEPTION " + error);
          this.$store.commit('appliances/appliances', []);
          this.dialog.error = true;
          setTimeout(function () {
            this.$functions.historyBack();
          }.bind(this), 3000);
        });
    },
    gammaChanged() {
      this.structures = {
        "CK": this.$functions.clone(structure_cp),
        "CP": this.$functions.clone(structure_cp),
        "MF Next": this.$functions.clone(structure_mfnext),
        "MYA": this.$functions.clone(structure_mya),
        "MP Next": this.$functions.clone(structure_mpnext),
        "EF Next": this.$functions.clone(structure_efnext),
        "SF": this.$functions.clone(structure_sf),
        "PRIME": this.$functions.clone(structure_prime),
      };
      this.step = -1;
      if(this.reportId==null) {
        this.report = {};
        for(let key of Object.keys(this.structures[this.gamma])) {
          this.report[key] = {};
        }
        this.report["imperial"] = !this.isCelsius;
        this.extras.imperial = this.report["imperial"];
        this.report["REPORT"].gamma = this.gamma;
        this.report["IMAGES"] = [];
        this.report["SIGNATURE"] = null;
        this.report["RIEPILOGO"] = {};
        setTimeout(function () {
          this.step = 0;
        }.bind(this), 10);
      } else {
        setTimeout(function () {
          this.step = Object.keys(this.structures[this.gamma]).length;
          this.updateButtonsStatus();
        }.bind(this), 10);
      }
      this.fillDomainModels();
      this.checkAllRules();
    }, 
    modelChanged() {
      this.extras.modelName = null;
      if(this.report["REPORT"]) {
        if(!this.reportId) {
          this.report["REPORT"]["serial_number"] = null;
        }
        this.populateExtras();
        // this.fillDomainSerialNumbers();
      }
    },
    populateExtras() {
      for(let i=0; i<this.domains.models.length; i++) {
        if(this.domains.models[i].code==this.report["REPORT"]["model"]) {
          this.extras.modelName = this.domains.models[i].rawName;
        }
      }
    },
    fillDomains() {
      for(let d in rawDomains) {
        this.domains[d] = [];
        for(let c in rawDomains[d]) {
          let code = c.replace(/_/g, "")
          this.domains[d].push({
            code: code,
            name: this.$t('report.domains.'+d+'.'+code)
          });
        }
      }
    },
    fillDomainCountries() {
      this.domains.countries = [];
      for(let i=0; i<this.countries.data.length; i++) {
        this.domains.countries.push({ code: this.countries.data[i].name, name: this.countries.data[i].name })
      }
    },
    fillDomainSerialNumbers() {
      this.domains.serialNumbers = [];
      if(this.report["REPORT"] && this.report["REPORT"]["model"]!=null) {
        for(let a of this.appliances) {
          if(a.modelId == this.report["REPORT"]["model"]) {
            this.domains.serialNumbers.push({ code: a.serialNumber, name: a.serialNumber });
          }
        }
      }
    },
    fillDomainModels() {
      let ms = [];
      for(let i=0; i<this.models.length; i++) {
        if(this.models[i].gamma === this.gamma) {
          let rawName = this.models[i].gamma + " " + this.models[i].name + (this.models[i].accessory ? " " + this.models[i].accessory : "");
          ms.push({ 
            code: this.models[i].modelId, 
            rawName: rawName,
            name: this.$functions.fixModelName(rawName)
          });
        }
      }
      this.domains.models = this.$functions.uniqByKeepFirst(ms, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
    },
    dataChanged(updatedData) {
      // console.log("UPDATEDDATA "+JSON.stringify(updatedData));
      this.report[updatedData.section][updatedData.key] = updatedData.value;
      if(updatedData.section!="RIEPILOGO") {
        this.checkField(
          this.structures[this.gamma][updatedData.section], 
          this.report[updatedData.section],
          updatedData.key
        );
        this.triggerRules(
          this.structures[this.gamma][updatedData.section], 
          this.report[updatedData.section],
          updatedData.key
        );
      }
      this.updateButtonsStatus();
    },
    imagesChanged(images) {
      this.report["IMAGES"] = images;
      console.log("IMAGES UPDATED");
    },
    signatureChanged(signatureData) {
      this.signatureData = signatureData;
      this.updateButtonsStatus();
      console.log("SIGNATURE DATA UPDATED");
    },
    exit() {
      this.$functions.historyBack();
    },
    back() {
      this.signatureData = null;
      this.updateButtonsStatus();
      this.step--;
    },
    save() {
      if(this.reportId==null) {
        this.saveCreate();
      } else {
        this.saveUpdate(false);
      }
    },
    saveCreate() {
      this.reportService.create(this.personaltoken, this.report)
        .then((data) => {
          if(data.code=='200') {
            this.reportId = '' + data.body; //Convert from number to string
            this.dialog.saveSuccess = true;
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    saveUpdate(isComplete) {
      this.reportService.update(this.personaltoken, this.reportId, this.report, isComplete)
        .then((data) => {
          if(data.code=='200') {
            if(isComplete) {
              this.dialog.sendSuccess = true;
              setTimeout(function() {
                this.$router.push({ name: 'report' });
              }.bind(this),3000);
            } else {
              this.dialog.saveSuccess = true;
            }
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    next() {
      if(this.isFormValid(this.step)) {
        this.step++;
      }
    },
    send() {
      let now = this.$moment();
      this.report["RIEPILOGO"]["test_date"] = now.format("DD/MM/YYYY") + ' (DD/MM/YYYY)';
      this.report["RIEPILOGO"]["test_date_timestamp"] = now.toDate().getTime();
      this.reportService.uploadSignature(this.personaltoken, this.reportId, this.signatureData)
        .then((data) => {
          if (data.code == '200') {
            console.log(data.body);
            this.report["SIGNATURE"] = data.body;
            this.saveUpdate(true);
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    isFormValid(step) {
      let index = 0;
      let isValid = true;
      for (const [key, value] of Object.entries(this.structures[this.gamma])) {
        if(step==null || index===this.step) {
          let vStructure = value;
          let vData = this.report[key];
          // console.log(`${JSON.stringify(vStructure)} ${JSON.stringify(vData)} ${index} ${this.step}`); 
          for(let vStructureField of vStructure) {
            // console.log("Checking "+vStructureField.key+"...");
            if(!this.isFieldValid(vStructureField, vData)) {
              isValid = false;
            }
          }
        }
        index++;
      }
      return isValid;
    },
    isFieldValid(vStructureField, vData) {
      if(vStructureField.mode==="simple") {
        // SIMPLE TYPE
        // console.log(vStructureField.key + " : " +vData[vStructureField.key])
        //Check optional/mandatory
        if(!this.isOptional(vStructureField.optional,vStructureField) && (
            typeof vData[vStructureField.key] === "undefined" ||
            vData[vStructureField.key]===null || 
            vData[vStructureField.key]===""
          )) {
          vStructureField.invalid = true;
          console.debug("Failed checks on "+vStructureField.key);
          return false;
        }
        //Other checks...
        if(vStructureField.format && !this.isFormatValid(vData[vStructureField.key], vStructureField.format)) {
          vStructureField.invalid = true;
          console.debug("Failed checks on "+vStructureField.key);
          return false;
        }
        //Tutto a posto
        vStructureField.invalid = false;
        return true;
      } else if(vStructureField.mode==="complex") {
        // COMPLEX TYPE
        let isValid = true;
        for(let child of vStructureField.childrens) {
          if(vStructureField.type==="column") {
            if(!this.isColumnChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          } else if(vStructureField.type==="timeslots") {
            if(!this.isTimeslotsChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          } else if(vStructureField.type==="absorptions") {
            if(!this.isAbsorptionsChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          } else if(vStructureField.type==="delta") {
            if(!this.isColumnChildValid(child, vStructureField, vData)) {
              isValid = false;
            }
          }
        }
        return isValid;
      }
      return true;
    },
    isColumnChildValid(child, vStructureField, vData) {
      //Check optional/mandatory
      if((child.c_type==="text" || child.c_type==="number" || child.c_type==="select" || child.c_type==="check") && !this.isOptional(child.optional,vStructureField) && (
          typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key]===null || 
          vData[child.c_key]===""
        )) {
        child.invalid = true;
        return false;
      } else if(child.c_type==="multiselect" && !this.isOptional(child.optional,vStructureField) && (
          typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key].length == 0
        )) {
        child.invalid = true;
        return false;
      }
      child.invalid = false;
      return true;
    },
    isTimeslotsChildValid(child, vStructureField, vData) {
      //Check optional/mandatory
      if(!this.isOptional(child.optional,vStructureField)) {
        if(typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key]===null || 
          vData[child.c_key]==="") {
            child.invalid = true;
            return false;
        } else {
          let fields = vData[child.c_key].split("|||");
          if(fields.length<2) {
            child.invalid = true;
            return false;
          } else {
            for(let field of fields) {
              if(!field) {
                child.invalid = true;
                return false;
              }
            }
          }
        }
      }
      //Check order
      let fields = vData[child.c_key].split("|||");
      if(fields[0]>fields[1]) {
        child.invalid = true;
        return false;
      }
      child.invalid = false;
      return true;
    },
    isAbsorptionsChildValid(child, vStructureField, vData) {
      //Check optional/mandatory
      if(!this.isOptional(child.optional,vStructureField)) {
        if(typeof vData[child.c_key] === "undefined" ||
          vData[child.c_key]===null || 
          vData[child.c_key]==="") {
            child.invalid = true;
            return false;
        } else {
          let fields = vData[child.c_key].split("|||");
          let count = child.c_type==="3A" ? 3 : 1;
          if(fields.length<count) {
            child.invalid = true;
            return false;
          } else {
            for(let field of fields) {
              if(!field) {
                child.invalid = true;
                return false;
              }
            }
          }
        }
      }
      child.invalid = false;
      return true;
    },
    isFormatValid(valueToCheck, regex) {
      return valueToCheck.match(regex);
    },
    isOptional(optional, vStructureField) {
      return optional || vStructureField.hidden || vStructureField.disabled;
    },
    checkField(vStructure, vData, key) {
      for(let vStructureField of vStructure) {
        if(vStructureField.mode==="simple") {
          if(vStructureField.key === key) {
            return this.isFieldValid(vStructureField, vData);
          }
        } else if(vStructureField.mode==="complex") {
          for(let child of vStructureField.childrens) {
            if(child.c_key === key) {
              if(vStructureField.type==="column") {
                return this.isColumnChildValid(child, vStructureField, vData);
              } else if(vStructureField.type==="timeslots") {
                return this.isTimeslotsChildValid(child, vStructureField, vData);
              } else if(vStructureField.type==="absorptions") {
                return this.isAbsorptionsChildValid(child, vStructureField, vData);
              } else if(vStructureField.type==="delta") {
                return this.isColumnChildValid(child, vStructureField, vData);
              }
            }
          }
        }
      }
    },
    checkAllRules() {
      for(let section in this.structures[this.gamma]) {
        this.triggerRules(
          this.structures[this.gamma][section], 
          this.report[section]
        );
      }
    },
    triggerRules(vStructure, vData, key) {
      //it works only for simple mode
      for(let vStructureField of vStructure) {
        if((!key || vStructureField.key === key) && vStructureField.rules) {
          let val = vData[vStructureField.key];
          for(let ruleKey in vStructureField.rules) {
            let ruleKeyArray = ruleKey.split('.');
            this.triggerRule(ruleKeyArray[0], ruleKeyArray[1], (val!=null && typeof val === 'object' ? val.code : val), vStructureField.rules[ruleKey]);
          }
        }
      }
    },
    triggerRule(targetSection, targetField, val, rule) {
      let vTargetStructure = this.structures[this.gamma][targetSection];
      for(let vTargetStructureField of vTargetStructure) {
        if(targetField==vTargetStructureField.key || targetField==vTargetStructureField.label) {
          if(rule.action==='hide') {
            vTargetStructureField.hidden = this.checkRule(rule, val);
          } else if(rule.action==='disable') {
            vTargetStructureField.disabled = this.checkRule(rule, val);
          }
          this.resetDisabledField(vTargetStructureField, targetSection);
          this.isFieldValid(vTargetStructureField, this.report[targetSection]);
        }
      }
    },
    checkRule(rule, val) {
      if(rule.condition.includes(typeof val === 'undefined' ? null : val)) {
        return true;
      }
      for(let condition of rule.condition) {
        if(typeof condition === 'string' && condition.startsWith("regex:")) {
          console.log("Checking regex "+condition.slice(6)+" on value "+val);
          let regex = new RegExp(condition.slice(6));
          if(regex.test(val)) {
            return true;
          }
        }
      }
      return false;
    },
    resetDisabledField(vTargetStructureField, targetSection) {
      if(vTargetStructureField.hidden || vTargetStructureField.disabled) {
        if(vTargetStructureField.mode==='simple') {
          this.report[targetSection][vTargetStructureField.key] = null;
        } else if(vTargetStructureField.mode==='complex') {
          for(let child of vTargetStructureField.childrens) {
            this.report[targetSection][child.c_key] = null;
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>